/**
 * CSRF token held in memory only. We deliberately do NOT persist it to
 * localStorage — losing it on full reload is fine; we fetch a fresh one
 * via /auth/me on app boot.
 */
let csrfToken: string | null = null;

export function getCsrfToken(): string | null {
  return csrfToken;
}

export function setCsrfToken(token: string | null): void {
  csrfToken = token;
}
